import React from 'react';
import { List, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { RedTimes, TableView } from '~/stylizations/styles';

export default function StockWriteOffView({ visible, onClose, stockWriteOff, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const mobileLabel = (text) => (
    <div>
      <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>
    </div>
  );
  const child = (text) => {
    if (text == null || text == '') {
      return (
        <div style={{ textAlign: 'center' }}>
          <RedTimes />
        </div>
      );
    }

    return <span style={{ fontSize: isMobile ? '12px' : '15px', fontWeight: 'bold' }}>{t(`${text}`)}</span>;
  };

  const stockWriteFields = [{ label: 'Motivo', value: stockWriteOff?.justification }];

  return (
    <Modal
      title={`${t('Informações')} - ${stockWriteOff?.id ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      {isMobile ? (
        <>
          <List
            bordered
            dataSource={stockWriteFields}
            renderItem={({ label, value }) => (
              <List.Item>
                <Typography.Text strong>{mobileLabel(label)}</Typography.Text>
                {child(value)}
              </List.Item>
            )}
          />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0 15px 0' }}>
            <Typography>{mobileLabel('Itens')}</Typography>
          </div>
          {stockWriteOff?.stock_write_off_items?.map((swoi, key) => (
            <List
              key={key}
              bordered
              dataSource={[swoi]}
              renderItem={({ item_name, amount }) => (
                <List.Item>
                  <Typography.Text strong>{mobileLabel(item_name)}</Typography.Text>
                  {child(amount)}
                </List.Item>
              )}
            />
          ))}
        </>
      ) : (
        <>
          <TableView
            pagination={false}
            rowKey={() => 'basic-1'}
            bordered
            columns={[{ title: label('Motivo'), dataIndex: 'justification', render: child }]}
            dataSource={[stockWriteOff]}
          />
          <TableView
            pagination={false}
            rowKey={() => 'basic-1'}
            bordered
            columns={[
              {
                title: label('Tipo de produto'),
                dataIndex: 'item_name',
                render: child,
              },
              {
                title: label('Quantidade'),
                dataIndex: 'amount',
                render: child,
              },
            ]}
            dataSource={stockWriteOff?.stock_write_off_items}
          />
        </>
      )}
    </Modal>
  );
}
